var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1112_1654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2083 4.08301H6.125C5.89294 4.08301 5.67038 4.17519 5.50628 4.33929C5.34219 4.50338 5.25 4.72594 5.25 4.95801V18.958C5.25 19.1901 5.34219 19.4126 5.50628 19.5767C5.67038 19.7408 5.89294 19.833 6.125 19.833H17.2083C17.4404 19.833 17.663 19.7408 17.8271 19.5767C17.9911 19.4126 18.0833 19.1901 18.0833 18.958V4.95801C18.0833 4.72594 17.9911 4.50338 17.8271 4.33929C17.663 4.17519 17.4404 4.08301 17.2083 4.08301ZM16.9167 18.6663H6.41667V5.24967H16.9167V18.6663Z",
    fill: "#CC0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1666 2.04199C15.1666 1.80993 15.0744 1.58737 14.9103 1.42327C14.7462 1.25918 14.5236 1.16699 14.2916 1.16699H3.20825C2.97619 1.16699 2.75363 1.25918 2.58953 1.42327C2.42544 1.58737 2.33325 1.80993 2.33325 2.04199V16.042C2.33325 16.2741 2.42544 16.4966 2.58953 16.6607C2.75363 16.8248 2.97619 16.917 3.20825 16.917H3.49992V2.33366H15.1666V2.04199Z",
    fill: "#CC0000"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1112_1654"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copyIcon.ab72d28945de2bd848bd06d542fc7a66.svg";
export { ForwardRef as ReactComponent };